module.exports = __webpack_public_path__ + "img/metrics.a4501fd5.png";